import { PrimaryButtonComponent } from './primary-button.component';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DemoMaterialModule } from 'src/app/demo-material-module';

@NgModule({
  imports: [
    CommonModule,
    DemoMaterialModule
  ],
  declarations: [
    PrimaryButtonComponent
  ],
  exports: [
    PrimaryButtonComponent
  ]
})
export class PrimaryButtonModule { }
